import get from 'lodash/get';
import { selectParsedCustomAttributes } from 'store/CustomAttributes/selectors';
import defaultFields from 'store/Manage/fields';

// eslint-disable-next-line import/prefer-default-export
export const selectManageFields = (state) => {
  const fields = get(state, 'preferences.manage_table', defaultFields);

  Object.keys(defaultFields).forEach((field) => {
    if (!fields[field]) {
      fields[field] = defaultFields[field];
    }
  });

  const customFields = selectParsedCustomAttributes(state);

  return {
    ...customFields,
    ...fields
  };
};
